module.exports = __webpack_public_path__ + "assets/img/rank1.bca78d5c.png";